/* eslint-disable no-undef */
import SelectCore from './SelectCore';
import { getRemoteDefaultValues } from './utils/remoteDefaultValues';

class SelectSchools extends SelectCore {
  componentDidMount() {
    const { defaultValue, networkId, onChange } = this.props;

    window
      .select2_schools($(this.select), {
        placeholder: this.defaultPlaceholder(),
        network_id: networkId,
      })
      .on('change', onChange);

    if (defaultValue) {
      getRemoteDefaultValues({
        searchUrl: Routes.search_schools_path({ ids: defaultValue }),
        selectElement: $(this.select),
      });
    }
  }

  componentDidUpdate() {
    window.select2_schools($(this.select), {
      placeholder: this.defaultPlaceholder(),
    });
  }

  defaultPlaceholder = () => {
    const { placeholder } = this.props;

    return placeholder || I18n.t('web.users.search.schools');
  };
}

export default SelectSchools;
